import React from "react"
import { CircleImage } from "../../../views/atoms/images/CircleImage"
import { FormattedMessage } from "react-intl"
import { Link, Typography } from "@carrotfertility/carotene-core"
import { RequirementCard } from "./requirement-card"

const MedicareAuLimitations = (): JSX.Element => (
  <RequirementCard
    icon={<CircleImage iconName="icn-documents" backgroundColor={"black-10"} />}
    title={<FormattedMessage defaultMessage="Medicare limitations" />}
    body={[
      <Typography key="medicare-limitations" variant="body1">
        <FormattedMessage
          defaultMessage="Because you don't have private insurance, you can only use Carrot funds for expenses not
          covered by Medicare. <link>Learn more in your benefit guide</link>."
          values={{
            link: (linkContent) => (
              <Link target="_blank" href={"/your-benefit-guide/coverage"} color="inherit">
                {linkContent}
              </Link>
            )
          }}
        />
      </Typography>
    ]}
  />
)

export default MedicareAuLimitations
